import { Button } from "antd"
import React from "react";

interface LinkTooltipI {
    href: string;
    linkDescription: string;
}

export const LinkTooltip = ({ href, linkDescription }: LinkTooltipI) => {

    const formatedHref = React.useMemo(() => {
        try {
            // Eğer protokol yoksa ekle
            const normalizedHref = href.startsWith("http") ? href : `https://${href}`;
            const url = new URL(normalizedHref);

            // www kısmını koruyalım, sadece protokolü atalım
            const host = url.host; // www.example.google.com
            const path = url.pathname !== "/" ? url.pathname : "";

            return host + path; // www.example.google.com/docs
        } catch {
            return href;
        }
    }, [href]);

    const formatedLİnkDescription = linkDescription === "" || linkDescription === null ? "İlgili bilgi bu linkteki kaynaktan alınmıştır." : linkDescription

    return (
        <span className="tooltip">
            <span
                style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "5px",
                    borderBottom: "2px solid #d9d9d9",
                    padding: "10px",
                    alignItems: "centerf",
                }}
            >

                <i
                    style={{
                        backgroundColor: "#2196f31a",
                        display: "flex",
                        alignItems: "center",
                        padding: "7px",
                        borderRadius: "5px",
                    }}
                    className="fi fi-rr-arrow-up-right-from-square"
                ></i>

                <span style={{ display: "flex", marginRight: 'auto', flexDirection: "column", justifyContent: 'center' }}>
                    <strong style={{ lineHeight: "1", whiteSpace: "nowrap", fontSize: "14px", }}>
                        REFERANS LİNK
                    </strong>
                    <span className="tooltip-link-span" style={{
                        overflow: 'hidden', whiteSpace: "nowrap", textOverflow: "ellipsis", lineHeight: "1", fontSize: "12px"
                    }}>{formatedHref}</span>
                </span>
                <Button
                    type="dashed"
                    style={{ color: '#2196f3' }}
                    onClick={() => window.open(href, "_blank", "noopener,noreferrer")}
                >
                    LİNKE GİT
                </Button>

            </span>

            <span style={{ display: 'flex', minHeight: '70px', padding: "10px", fontSize: "14px" }}>
                {formatedLİnkDescription}
            </span>
        </span>
    );
};